import React from "react";
import Button from "@mui/material/Button";
import Tooltip from "@material-ui/core/Tooltip";

function ToolButton(props) {
  return (
    <div>
      <Tooltip disableFocusListener title={props.tooltip} arrow>
        <Button
          {...props}
          size={"medium"}
          variant={"contained"}
          className={props.className}
          onClick={props.onClick}
        >
          {props.icon}
        </Button>
      </Tooltip>
    </div>
  );
}

export default ToolButton;
